import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";
import { Cookies } from "react-cookie";

export const updateVisitorPin = createAsyncThunk("updateVisitorPin", async (data) => {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");
    const response = await AxiosInstance.put(
      `${API_KEY}/api/society/access/update`,
      data,
      {
        headers: { Authorization: `Barear ${token}` },
        "Content-Type": "application/json",
      }
    );

    return response;
  } catch (error) {
    if (error.response) {
      throw error.response.data.message;
    } else {
      throw error;
    }
  }
});

const initialState = {
  isLoading: false,
  updateVisitorPinData: null,
  isError: false,
  errorMessage: "",
};
const updateVisitorPinSlice = createSlice({
  name: "updateVisitorPin",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(updateVisitorPin.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateVisitorPin.fulfilled, (state, action) => {
      state.isLoading = false;
      state.updateVisitorPinData = action.payload;
    });
    builder.addCase(updateVisitorPin.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default updateVisitorPinSlice.reducer;
